<template lang='pug'>
  i.svg-icon.svg-icon-follower
    svg(
      :fill='color'
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100'
    )
      path(d='M23.881,45.921c4.113,0,7.447-3.614,7.447-8.072c0-4.459-3.334-8.074-7.447-8.074 c-4.112,0-7.447,3.615-7.447,8.074C16.438,42.305,19.771,45.917,23.881,45.921z M76.002,45.921c4.113,0,7.446-3.614,7.446-8.072 c0-4.459-3.333-8.074-7.446-8.074c-4.112,0-7.446,3.615-7.446,8.074l0,0c0.004,4.463,3.344,8.076,7.46,8.072l0,0H76.002z M79.725,49.958H72.27c-1.966-0.002-3.85,0.842-5.242,2.347c4.781,2.823,8.028,7.956,8.735,13.81h7.679 c2.057,0,3.724-1.805,3.724-4.029c0-0.004,0-0.008,0-0.008v-4.037C87.165,53.583,83.837,49.965,79.725,49.958L79.725,49.958z M49.942,49.958c7.196,0,13.032-6.325,13.032-14.128c0-7.802-5.836-14.127-13.032-14.127c-7.198,0-13.033,6.325-13.033,14.127 c0,0.002,0,0.002,0,0.004c-0.002,7.799,5.827,14.122,13.021,14.124C49.934,49.958,49.938,49.958,49.942,49.958z M58.876,53.995 h-0.97c-5.018,2.688-10.913,2.688-15.936,0h-0.965c-7.402,0-13.402,6.505-13.403,14.531v3.629c0,3.342,2.5,6.054,5.583,6.054l0,0 h33.509c3.081-0.002,5.575-2.712,5.575-6.054v-3.629c0-8.022-5.993-14.531-13.394-14.534V53.995z M32.849,52.306 c-1.392-1.505-3.278-2.349-5.244-2.347h-7.448c-4.11,0.004-7.443,3.618-7.446,8.074v4.037c-0.002,2.225,1.66,4.033,3.716,4.037 c0.002,0,0.004,0,0.008,0h7.667C24.821,60.253,28.069,55.129,32.849,52.306z')

</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },

}
</script>